const mockExams = {
  mockExam: "Examen Blanc",
  mockExams: "Examens Blancs",
  mockExamsImport: "Import des examens blancs",
  creation: "Création de l'examen blanc",
  update: "Modification de l'examen blanc",
  creationInstruction: "Définissez les paramètres de l'examen blanc",
  noExerciseInMockExam: "Il n'y a pas encore d'exercice dans cet examen blanc.",
  mockExamsExplanation:
    "Les examens blancs sont des devoirs que les élèves ne feront qu’une fois, avec les mêmes exercices et les mêmes questions pour tous les élèves.",
  badColumnsErrors:
    "La définition des colonnes du fichier n'est pas bonne. Nom des colonnes attendu : UUID ; Theme ; Level ; Number ; Name.",
  mockExamsFinding:
    "L'examen blanc apparaitra dans la page 'Suivre mes devoirs'",
  isAMockTestWarning:
    "Ce devoir est un examen blanc. Il ne pourra être complété qu’une seule fois.",
  startMockTest: "Commencer l'examen blanc",
  assignMockTest: "Assigner un examen blanc",
  viewTest: "Voir la copie",
  copyOf: "Copie de {name}",
  view: "Visualisation d'un examen blanc",
};

export default mockExams;
